import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import { AppState } from '../../../store/reducers/root';
import { getFirstPendingCommandConfirmation } from '../../../store/selectors/confirmation';
import {
  getAppDisplayName,
  getAuthenticated,
  getUserName,
} from '../../../store/selectors/session';
import { getSystemNotificationsSortedByStartTs } from '../../../store/selectors/systemNotifications';

import MainView from './MainView';

const mapStateToProps = (state: AppState) => ({
  appName: getAppDisplayName(state),
  authenticated: getAuthenticated(state),
  systemNotifications: getSystemNotificationsSortedByStartTs(state),
  userName: getUserName(state),
  isShowConfirmation: !!getFirstPendingCommandConfirmation(state),
});

const connector = connect(mapStateToProps);

export type MainViewContainerProps = ConnectedProps<typeof connector>;

export default connector(MainView);
